import React from 'react';
import * as S from './style';

export const AlertComp=(props)=>{
    return(
        <S.alerteExcluir>
            <div className='alertar'>
                <label>{props.alertDescrit}</label>
                <div className='simnao'>
                    <button 
                    className='nao'
                    onClick={props.seNao}
                    >
                        NÃO
                    </button>
                    <button 
                    className='sim'
                    onClick={props.seSim}
                    >
                        SIM
                    </button>
                </div>
            </div>
        </S.alerteExcluir>
)}

//-----------------------------------------------------

export const AlertJaExiste=(props)=>{   
    return(
        <S.alerte>
            <div className='alertaJaExiste'>
                <div className='header'>
                    ⚠️
                </div>
                <label className='titulo'>
                    Condutor Localizado!
                </label>
                <div className='nomeCliente'>
                    {props.nomeCliente || 'Nome não informado'}
                </div>
                <div className='footer'>
                    <button 
                        className='btnFechar'
                        onClick={props.onFechar}
                        title="Fechar"
                    >
                        ✕
                    </button>
                    <button 
                        className='btnOk'
                        onClick={props.onOk}
                    >
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </S.alerte>
    )
}